import { default as Axios, } from "axios";
export function axiosCallWithLocalhostFallback(call, config, localhostReturnData, localhostReturnStatus = 200) {
    if (localhostReturnData && call.domain.indexOf("localhost") >= 0) {
        if (localhostReturnStatus < 400) {
            return Promise.resolve({
                data: localhostReturnData,
                status: localhostReturnStatus,
                statusText: "OK",
                headers: {},
                config: {},
            });
        }
        else {
            const error = {
                config: {},
                response: {
                    data: localhostReturnData,
                    status: localhostReturnStatus,
                    statusText: "NOT OK",
                    headers: [],
                    config: {},
                },
            };
            return Promise.reject(error);
        }
    }
    else {
        return Axios.get(`https://${call.serviceName}.${call.domain}/${call.pathWithoutLeadingSlash}`, config);
    }
}
export function axiosPost(call, config, data, sample, status = 200) {
    if (sample && call.domain.indexOf("localhost") >= 0) {
        if (status < 400) {
            return Promise.resolve({
                data: sample,
                status: status,
                statusText: "OK",
                headers: {},
                config: {},
            });
        }
        else {
            const error = {
                config: {},
                response: {
                    data: sample,
                    status: status,
                    statusText: "NOT OK",
                    headers: [],
                    config: {},
                },
            };
            return Promise.reject(error);
        }
    }
    else {
        return Axios.post(`https://${call.serviceName}.${call.domain}/${call.pathWithoutLeadingSlash}`, data, config);
    }
}
export function toGenericError(error) {
    var _a, _b, _c;
    if (typeof error === "string") {
        return {
            data: error,
        };
    }
    return {
        flowId: (_a = error.response) === null || _a === void 0 ? void 0 : _a.headers["x-flow-id"],
        status: (_b = error.response) === null || _b === void 0 ? void 0 : _b.status,
        data: (_c = error.response) === null || _c === void 0 ? void 0 : _c.data,
    };
}
//# sourceMappingURL=axios.js.map